export function find(query) {
    let result = document.querySelector(query);
    if (result == null) {
        throw new Error(`オブジェクトが見つかりませんでした: ${query}`);
    }
    else {
        return result;
    }
}
export function findAll(query) {
    let result = document.querySelectorAll(query);
    if (result == null) {
        throw new Error(`オブジェクトが見つかりませんでした: ${query}`);
    }
    else {
        return result;
    }
}
export function addBlankToExternalLinks() {
    var _a;
    const aTags = findAll("a");
    for (let aTag of aTags) {
        if (((_a = aTag.getAttribute("href")) === null || _a === void 0 ? void 0 : _a.match(/http/)) != null) {
            aTag.setAttribute("target", "_blank");
        }
    }
}
